import type { FC, ReactNode } from 'react'
import { cn } from '@/helpers/utils'

interface InputWrapperProps {
	children: ReactNode
	className?: string
	hasError: boolean
	touched: boolean
	visibilityToggle?: boolean
}

export const InputWrapper: FC<InputWrapperProps> = ({
	children,
	className,
	hasError,
	visibilityToggle
}) => {
	return (
		<div
			className={cn(
				'relative flex w-full cursor-pointer items-center gap-1 border border-neutral-300 bg-neutral-white transition-all duration-200 ease-in-out',
				visibilityToggle ? 'rounded-l-lg' : 'rounded-lg',
				hasError && 'border-danger-300',
				'has-[input:disabled]:cursor-not-allowed has-[input:disabled]:bg-neutral-100 has-[input:disabled]:text-neutral-500',
				!hasError &&
					'hover:not-has-[input:disabled]:border-neutral-300 hover:not-has-[input:disabled]:shadow-[0_1px_2px_0_rgba(16,24,40,0.05),0_0_0_4px_var(--color-neutral-100)]',
				hasError &&
					'hover:not-has-[input:disabled]:border-danger-300 hover:not-has-[input:disabled]:shadow-[0_1px_2px_0_rgba(16,24,40,0.05),0_0_0_4px_var(--color-danger-100)]',
				className
			)}
		>
			{children}
		</div>
	)
}

InputWrapper.displayName = 'InputWrapper'
